import React, { ReactElement } from 'react'
import styled from 'styled-components'


const Dot = styled.div`
  width: 5px;
  height: 5px;
  color: black;
  background: black;
  border-radius: 100%;
  position: absolute;
  bottom: -5px;
  margin: 0;
  margin-left: 0 !important;
`
const ToolbarToolClicker = (props) => {
    return (
        <>
            <div className={'toolbarTool'}>
                <div onClick={() => props.onChange()} className='icon'>
                    <img src={props.icon}/>
                </div>
                {props.active && <Dot />}

                <div />
            </div>
            <style jsx="true">
                {`
                  .progressBar {
                    position: relative;
                    height: 35px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 286px;
                    padding: 0 10px;
                    background: rgba(244, 247, 254, 1);
                    border-radius: 10px;
                    z-index: 1;
                    top: 106%;
                  }

                  .toolbarTool {
                    position: relative;
                    height: max-content;
                    width: max-content;
                    display: flex;
                    justify-content: center;
                  }

                  .icon {
                    cursor: pointer;
                    width: max-content;
                  }
                `}
            </style>
        </>
    )
}

export default ToolbarToolClicker
